import { Component, type ErrorInfo, type ReactNode } from "react";

import { AppError } from "@domain/context/AppSettingsProvider";
import { logger } from "@domain/infrastructure/logger";

interface Props {
    children?: ReactNode;
    setError: (error: AppError | null) => void;
}

export class ErrorBoundary extends Component<Props, unknown> {
    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        logger.crit(error, errorInfo);
        this.props.setError(AppError.ReactRendering);
    }

    public render() {
        return this.props.children;
    }
}
